import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api';

export const fetchTradingConfigs = createAsyncThunk(
  'tradingConfigs/fetch',
  async (params = {}) => {
    const response = await api.get('/api/trading-configs/', { params });
    return response.data;
  }
);

export const createTradingConfig = createAsyncThunk(
  'tradingConfigs/create',
  async (data) => {
    const response = await api.post('/api/trading-configs/', data);
    return response.data;
  }
);

export const updateTradingConfig = createAsyncThunk(
  'tradingConfigs/update',
  async ({ uuid, data }) => {
    const response = await api.patch(`/api/trading-configs/${uuid}/`, data);
    return response.data;
  }
);

export const deleteTradingConfig = createAsyncThunk(
  'tradingConfigs/delete',
  async (uuid) => {
    await api.delete(`/api/trading-configs/${uuid}/`);
    return uuid;
  }
);

const tradingConfigSlice = createSlice({
  name: 'tradingConfigs',
  initialState: {
    configs: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch trading configs
      .addCase(fetchTradingConfigs.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTradingConfigs.fulfilled, (state, action) => {
        state.loading = false;
        state.configs = action.payload.results || action.payload;
      })
      .addCase(fetchTradingConfigs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Create trading config
      .addCase(createTradingConfig.fulfilled, (state, action) => {
        state.configs.unshift(action.payload);
      })
      // Update trading config
      .addCase(updateTradingConfig.fulfilled, (state, action) => {
        const index = state.configs.findIndex(c => c.uuid === action.payload.uuid);
        if (index !== -1) {
          state.configs[index] = action.payload;
        }
      })
      // Delete trading config
      .addCase(deleteTradingConfig.fulfilled, (state, action) => {
        state.configs = state.configs.filter(c => c.uuid !== action.payload);
      });
  },
});

export default tradingConfigSlice.reducer;